// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline-module--headline--2AB7k","headlineLeft":"headline-module--headlineLeft--3Yck4"};